import { FP } from "./tokens";

// Shared sx for MUI DataGrid that matches the FinancePro pattern (clean white
// surface, soft borders, navy header text, hover row tint).
export const fpDataGridSx = {
  border: "none",
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: FP.color.surfaceAlt,
    color: FP.color.textSecondary,
    fontSize: "0.72rem",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    borderBottom: `1px solid ${FP.color.border}`,
  },
  "& .MuiDataGrid-columnHeaderTitle": { fontWeight: 700 },
  "& .MuiDataGrid-cell": {
    fontSize: "0.875rem",
    color: FP.color.textPrimary,
    borderBottom: `1px solid ${FP.color.border}`,
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: FP.color.surface,
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: `1px solid ${FP.color.border}`,
  },
  "& .MuiCheckbox-root.Mui-checked": { color: FP.color.navy },
};

export default fpDataGridSx;
